import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";

import { listValue } from "../../utils/constant";
import { staticTexts } from "../../utils/Translate";

import "./versionList.m.css";

const VersionList = ({ publisherAttributes }) => {
  const value = staticTexts(publisherAttributes.lang).language;

  return listValue.map((item, index) => (
    <li key={index} styleName="radio-item">
      <Link
        href={
          item.key === "bangla" ? publisherAttributes.bangla_sketches_host : publisherAttributes.english_sketches_host
        }
      >
        <input type="radio" id={item.id} name={item.value} value={item.value} />
        <label styleName={`version-list ${value === item.value ? "current-version" : ""}`}>{item.value}</label>
      </Link>
    </li>
  ));
};

const mapStateToProps = state => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
});

export default connect(mapStateToProps, null)(VersionList);
